export default {
  breadcrumb: [],
  entries: [],
}
